import { Tooltip } from "@/components/ui/tooltip";
import { MotivoInList } from "@/pages/config/motives/schema/motives.schema";
import { AppColors } from "@/styles/colors";
import { Text } from "@chakra-ui/react";
import { PenLine } from "lucide-react";

interface Props {
  item: MotivoInList;
  handleEdit: (item: MotivoInList) => void;
}

export const MotivesActions = ({ handleEdit, item }: Props) => {
  return (
    <Tooltip
      showArrow
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={
        <Text color={AppColors.WHITE_SECONDARY} fontSize="14px">
          Editar
        </Text>
      }
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <PenLine
        data-testid={`"role-edit-button"-${item?.id}`}
        size="20px"
        cursor="pointer"
        style={{ justifySelf: "flex-end", marginRight: "16px" }}
        onClick={() => handleEdit(item)}
      />
    </Tooltip>
  );
};
